import baysportLogo from "../assets/logo.png";
import L from "../constants/baysportLabels";
import {
  applyPortalBrandingToRoot,
  applyPortalThemeMode,
  buildClientHeroTheme,
  clearPortalThemeMode,
  clubBrandingSource,
  mediaUrl,
  resolvePortalThemeMode,
} from "./clientHeroTheme";

/** Есть ли кастомный бренд клуба на страницах входа. */
export function clinicHasAuthBranding(clinic) {
  const f = clinic?.features || {};
  return Boolean(
    f.branding || f.branding_lite || f.splash_branding || f.white_label,
  );
}

/**
 * Бренд для страниц входа / сброса пароля / регистрации по ссылке.
 * Полный брендинг — цвета и тема; только lite — логотип без цвета с прошлого тарифа.
 */
export function resolveAuthPageBranding(clinic) {
  const clubName = String(clinic?.name || "").trim();
  const f = clinic?.features || {};
  const fullBrand = Boolean(f.branding || f.white_label || f.splash_branding);
  const liteOnly = Boolean(f.branding_lite) && !fullBrand;
  const personalized = clinicHasAuthBranding(clinic);
  const logoSrc = mediaUrl(clinic?.logo_url) || null;
  const themeMode =
    fullBrand && resolvePortalThemeMode(clinic) === "dark" ? "dark" : "light";

  if (!personalized) {
    return {
      personalized: false,
      logoSrc: baysportLogo,
      brandTitle: L.productName,
      showProductName: true,
      applyColors: false,
      themeMode: "light",
      clubTag: clubName || null,
    };
  }

  return {
    personalized: true,
    logoSrc: logoSrc || null,
    brandTitle: clubName || null,
    showProductName: false,
    applyColors: fullBrand && !liteOnly,
    themeMode,
    clubTag: null,
  };
}

/** Применить цвета и светлую/тёмную тему клуба на documentElement. */
export function applyAuthPageTheme(clinic) {
  const brand = resolveAuthPageBranding(clinic);

  if (!brand.applyColors) {
    clearPortalThemeMode();
    return brand;
  }

  const source = clubBrandingSource(clinic);
  const dark = brand.themeMode === "dark";
  applyPortalThemeMode(dark ? "dark" : "light");
  const theme = buildClientHeroTheme(source);
  if (theme) applyPortalBrandingToRoot(theme, { dark });
  return brand;
}
